// --- src/admin/AdminLayout.jsx ---
import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';
const AdminLayout = () => (
  <div className="flex h-screen bg-bg text-txt">
    <Sidebar />
    <div className="flex-1 flex flex-col">
      <Navbar />
      <main className="p-6 overflow-auto">
        <Outlet />
      </main>
    </div>
  </div>
);
export default AdminLayout;